import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import { ReactNode } from 'react';
import { ReactComponent as Add } from '../../../../../../Asset/svg/add_white.svg';
import { ReactComponent as Browser } from '../../../../../../Asset/svg/browser.svg';
import { ReactComponent as Delete } from '../../../../../../Asset/svg/delete.svg';
import { ReactComponent as Move } from '../../../../../../Asset/svg/move.svg';
import { ReactComponent as Save } from '../../../../../../Asset/svg/save.svg';
import { useEditSharedStyles } from '../Edit.styles';
import { UseEditEbookReturn } from '../hooks/useEditEbook';
import { useBlockToolbarStyles } from './BlockToolbar.styles';
import BlockTypeMenu from './BlockTypeMenu';

type BlockToolbarProps = Pick<
  UseEditEbookReturn,
  | 'allBlocks'
  | 'blockSelected'
  | 'handleAddUpdate'
  | 'handleChangeInput'
  | 'handleInputChange'
  | 'handleMoveToPosition'
  | 'indexSelected'
  | 'moveElement'
  | 'scrollToSection'
  | 'setOpenExit'
  | 'setOpenModal'
  | 'setOpenPublish'
  | 'setShowMenu'
  | 'showMenu'
  | 'stateEdition'
  | 'addLink'
  | 'editStyleEditor'
  | 'editPosition'
  | 'position'
  | 'valueInput'
  | 'templateBlocks'
  | 'selectType'
  | 'imgRef'
  | 'handleChangeImg'
> & {
  barEdition?: ReactNode;
};

const BlockToolbar = ({
  allBlocks,
  blockSelected,
  handleAddUpdate,
  handleChangeInput,
  handleInputChange,
  handleMoveToPosition,
  indexSelected,
  moveElement,
  scrollToSection,
  setOpenExit,
  setOpenModal,
  setOpenPublish,
  setShowMenu,
  showMenu,
  valueInput,
  templateBlocks,
  selectType,
  imgRef,
  handleChangeImg,
  barEdition,
}: BlockToolbarProps) => {
  const classes = useBlockToolbarStyles();
  const shared = useEditSharedStyles();
  const selectedBlock = allBlocks[indexSelected];
  const maxIndex = Math.max((allBlocks?.length || 1) - 1, 0);

  const addBlockControl = (
    <div className={classes.blockTypeMenuWrap}>
      <button
        type="button"
        className={classes.addBlockButton}
        onClick={() => setShowMenu(!showMenu)}>
        <Add className={shared.whiteActionIcon} />
        Ajouter un bloc
        <KeyboardArrowDown className={shared.whiteActionIcon} />
      </button>
      {showMenu && (
        <BlockTypeMenu
          templateBlocks={templateBlocks}
          imgRef={imgRef}
          onSelectType={selectType}
          onImageChange={handleChangeImg}
        />
      )}
    </div>
  );

  return (
    <div className={classes.blockToolbar}>
      <div className={classes.toolbarMainRow}>
        <div className={classes.toolbarActionsGroup}>
          <div className={classes.toolbarLegacyIcons}>
          <button
            type="button"
            className={classes.toolbarIconButton}
            aria-label="Quitter sans sauvegarder"
            onClick={() => setOpenExit(true)}>
            <Move className={classes.toolbarLegacyIcon} />
          </button>
          <button
            type="button"
            className={classes.toolbarIconButton}
            aria-label="Sauvegarder comme brouillon"
            onClick={() => handleAddUpdate()}>
            <Save className={classes.toolbarLegacyIcon} />
          </button>
          <button
            type="button"
            className={classes.toolbarIconButton}
            aria-label="Publier"
            onClick={() => setOpenPublish(true)}>
            <Browser className={classes.toolbarLegacyIcon} />
          </button>
        </div>

        <div className={classes.toolbarCenter}>
          <div className={classes.positionGroup}>
            <span className={classes.toolbarLabel}>Position du bloc</span>
            <input
              type="text"
              className={classes.positionInput}
              value={valueInput}
              onChange={event => handleInputChange(event.target.value)}
              onKeyDown={event => {
                if (event.key === 'Enter') handleMoveToPosition();
              }}
              aria-label="Position du bloc"
            />
            <div className={classes.arrowGroup}>
              <KeyboardArrowUp
                className={classes.arrowButton}
                onClick={() => {
                  if (indexSelected > 0 && allBlocks?.length > 0) {
                    const newIndex = indexSelected - 1;
                    moveElement(indexSelected, newIndex);
                    scrollToSection(newIndex);
                  }
                }}
              />
              <KeyboardArrowDown
                className={classes.arrowButton}
                onClick={() => {
                  if (indexSelected < maxIndex && allBlocks?.length > 0) {
                    const newIndex = indexSelected + 1;
                    moveElement(indexSelected, newIndex);
                    scrollToSection(newIndex);
                  }
                }}
              />
            </div>
            <button
              type="button"
              className={classes.okButton}
              disabled={valueInput === '' || valueInput === indexSelected + 1}
              onClick={handleMoveToPosition}>
              OK
            </button>
          </div>

          <button type="button" className={classes.deleteAction} onClick={() => setOpenModal(true)}>
            <Delete className={classes.deleteIcon} />
            <span>Supprimer le bloc</span>
          </button>

          {selectedBlock?.bloc_template === 2 && (
            <div className={classes.typeSelectorWrap}>
              <span className={classes.typeSelectorLabel}>Type de titre</span>
              <select
                className={classes.typeSelector}
                value={blockSelected?.title_type || 'title'}
                onChange={event =>
                  handleChangeInput(event.target.value, indexSelected, 'title_type')
                }>
                <option value="title">Titre</option>
                <option value="subtitle">Sous titre</option>
              </select>
            </div>
          )}

          {selectedBlock?.bloc_template === 1 && (
            <div className={classes.typeSelectorWrap}>
              <span className={classes.typeSelectorLabel}>Type de texte</span>
              <select
                className={classes.typeSelector}
                value={blockSelected?.contentForType || 'normal'}
                onChange={event =>
                  handleChangeInput(event.target.value, indexSelected, 'contentForType')
                }>
                <option value="normal">Normal</option>
                <option value="citation">Citation</option>
                <option value="encyclopedia">Encyclopedie</option>
              </select>
            </div>
          )}
        </div>
      </div>

        {!barEdition && addBlockControl}
      </div>

      {barEdition && (
        <div className={classes.toolbarSubHeaderRow}>
          <div className={classes.barEditionWrap}>{barEdition}</div>
          {addBlockControl}
        </div>
      )}
    </div>
  );
};

export default BlockToolbar;
